export default __webpack_public_path__ + "static/media/eye-icon-outlined.7e908ec3.svg";